var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-start align-center font-weight-medium font-2 w100 px-0"},[_c('div',{staticClass:"offer rounded py-1 px-2"},[_c('div',[_vm._v("Termina en "+_vm._s(_vm.limitedTimeOfferMsg))])])])}
var staticRenderFns = []

export { render, staticRenderFns }